import React, { ReactElement } from 'react';
import FormatService from '../../services/format-service';
import useStylesImage from './image.styles';

const Image: ReactMemoComponent = React.memo((props: ReactComponentProps): ReactElement => {
  const {
    isDefault,
    isSquare,
    isCentered,
    isSmall,
    text,
    link,
    className,
  } = props;

  const { classes } = useStylesImage();

  const squareClassName: string | undefined = isSquare ? classes.imageSquare : undefined;
  const centeredClassName: string | undefined = isCentered ? classes.imageCentered : undefined;
  const smallClassName: string | undefined = isSmall ? classes.imageSmall : undefined;

  return (
    <img
      alt={text}
      src={link}
      className={FormatService.formatClassNames(
        !isDefault ? classes.image : undefined,
        squareClassName, centeredClassName, smallClassName, className,
      )}
    />
  );
});

export default Image;
